import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';

interface DeleteLandingPageDesignGroupParams {
  groupId: number;
  shouldShowNotifications?: boolean;
}

const deleteLandingPageDesignGroup = async (groupId: number) => {
  return await EXPRESS_API.delete(
    `/superadmin/landing-page-design-groups/${groupId}`
  );
};

export const useDeleteGroupMutation = (
  params: DeleteLandingPageDesignGroupParams,
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { shouldShowNotifications, groupId } = params;

  return useMutation(() => deleteLandingPageDesignGroup(groupId), {
    onSuccess: async () => {
      if (shouldShowNotifications) {
        successToast({
          title: 'Group has been successfully deleted!',
        });
      }

      await queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGN_GROUPS',
        exact: false,
      });

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: error =>
      showError(error || 'An error occured while trying to delete the group!'),
  });
};
